
class FirewallTestCtrl
  @$inject = ['$uibModalInstance','options']
  constructor: ($uibModalInstance, options)->
    if options.device
      @device = options.device
    @testing = false;
    @testFirewall()
    
    @instance = $uibModalInstance
    {@title="Confirm"} = options
  
  testFirewall: ()->
    @result = null;
    @testing = true
    @device.$firewall(@file).then (data)=>
      @result = data
      @testing = false

  upload: (file)->
    @file = file;
    @filename = file.name

  confirm: ()->
    @instance.close()
  cancel: ()->
    @instance.dismiss()
    
module.exports = FirewallTestCtrl



// WEBPACK FOOTER //
// ./src/component/device/firewall-test/controller.coffee